import React, {useContext} from "react";
import Img from "../../common/Img";
import {PopUpContext} from "../../../contexts/popUpContext";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";

const InfoHeader = ({student, callback}) => {
    const {togglePopUp} = useContext(PopUpContext);

    return (
        <div id="general-info-header">
            <div className="student-detail five-col">
                <div className="detail_item">
                    <p>نام</p>
                    <p>{student.student_name ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p>کد دانشجو</p>
                    <p>{student.aria_id ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p> شماره تماس</p>
                    <p>{student.student_phone ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p>دپارتمنت</p>
                    <p>{student.department_name ?? "-"}</p>
                </div>

                <div className="detail_item">
                    <div style={{width:"50%", float: "right"}}>
                        <p>جنسیت</p>
                        <p>{student.student_gender}</p>
                    </div>

                    <div className="left-content">
                    {student ? <MainButton
                        type="pen"
                        title={lbl.Edit}
                        handleClick={() => togglePopUp({
                            form: "student-form",
                            edit: student,
                            callback: callback,
                        })}
                    /> : ''}
                </div>
                </div>

                <div className="detail_item">
                    <p>نام پدر</p>
                    <p>{student.student_father_name ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p>کد اداره ملی</p>
                    <p>{student.nexa_id ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p>پوهنحی</p>
                    <p>{student.faculty_name ?? "-"}</p>
                </div>
                <div className="detail_item">
                    <p>صنف</p>
                    <p>{student.class_desc ?? "-"}</p>
                </div>


                <div className="detail_item">
                    <p>ایمیل</p>
                    <p>{student.student_email}</p>
                </div>
            </div>
            <div className="profile-image">
                <Img src={student.student_photo} alt=""/>
            </div>
        </div>
    );
};

export default InfoHeader;
